// extracted by mini-css-extract-plugin
export var appear = "LinkGroup-module--appear--e8abc";
export var contents = "LinkGroup-module--contents--c013f";
export var root = "LinkGroup-module--root--c031b";